import GaugeAxis from'../../../fc-core/src/axis/gauge';import{componentFactory}from'../../../fc-core/src/lib';export default function(a){let b=a.getChildren('canvas')[0];componentFactory(a,GaugeAxis,'scale',1,a._feedAxesRawData()),a.getChildren('scale')[0].setLinkedItem('canvas',b),a.addToEnv('scale',a.getChildren('scale')[0])}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-widgets/src/factories/gauge-axis.js
// module id = null
// module chunks = 